module.exports = __webpack_public_path__ + "img/AlejandroLozano.86b4f2d7.png";